import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Card } from '@asuresoftware/asure.strata-react';

import { state } from '../framework/state';
import { Parcel } from '../framework/Parcel';
import { Widget } from '../framework/PortalPlugin';

namespace Dashboard {
  export interface Props { }
  export interface State {
    widgets: Widget[];
  }
}

injectStyles();

export class Dashboard extends React.Component<Dashboard.Props, Dashboard.State> {
  state: Dashboard.State = { widgets: [] };

  componentDidMount() {
    this.setState({ widgets: state.dashboardWidgets.sort((w1, w2) => w1.sortKey.localeCompare(w2.sortKey)) });
  }

  render() {
    return (
      <Container fluid={true}>
        <Row className="d-flex">
          <Col className="col-12 bg-gray-100 vhmh-100">
            <div className="py-3" style={{ maxWidth: '1380px' }}>
              <Container fluid={true} id="portal-dashboard">
                <Row>
                  {this.state.widgets.map(({ parcelConfig }, index) => (
                    <Col key={index} className={`col-12 col-lg-6 p-0 p-sm-2 ${index !== this.state.widgets.length - 1 ? 'mb-3' : ''} mb-sm-0`}>
                      <Card>
                          <Parcel config={parcelConfig}/>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

function injectStyles() {
  const style = document.createElement('style');
  style.innerHTML = `
    .vhmh-100 {
      /* used to set body height to viewport minus header */
      min-height: calc(100vh - 75px) !important;
    }
  `;
  document.body.appendChild(style);
}



// WEBPACK FOOTER //
// ./src/portal-react-app/Dashboard.tsx